"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: 'AppHeader',
    props: ['title'],
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/globals/AppHeader.vue
// module id = qV20
// module chunks = 1